import { render } from "./LoginPanel.vue?vue&type=template&id=33eb7068"
import script from "./LoginPanel.vue?vue&type=script&lang=ts"
export * from "./LoginPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script